export default __webpack_public_path__ + "static/media/Armguards of the Defiant.53271d0c.jpg";